export * from "./OrganisationListResult.d";
